import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

//
Vue.use(Router)

//
const routerInstance = new Router({
    base: process.env.BASE_URL,
    routes: [
        {
            path: "/yqyTest",
            name: "yqyTest",
            component: () => import("./views/YqyTest"),
            meta: { title: "测试" },
        },

        {
            path: '/',
            component: () => import('./views/Index.vue'),
            meta: {
                title: '云商舟山',
            },
        },

        {
            path: '/login',
            component: () => import('#/common_components/Login.vue'),
            props: route => {
                return {
                    fromUrl: route.query.fromUrl,
                }
            },
            meta: {
                title: '登录',
            },
        },

        {
            path: '/nianhuo',
            component: () => import('./views/NianHuo.vue'),
            meta: {
                title: "舟山市网上年货节"
            }
        },
        {
            path: '/shop',
            component: () => import('./views/ShopProxy.vue'),
            props: route => {
                return {
                    shopId: parseInt(route.query.shopId),
                    productId: route.query.productId && route.query.productId.length > 0 ? parseInt(route.query.productId) : -1,
                }
            },
            meta: {
                title: '店铺',
                updateCustomerAddress: true,
            },
        },
        {
            path: '/productList',
            component: () => import('./views/ProductList.vue'),
            props: route => {
                return {
                    typeName: route.query.typeName,
                    searchName: route.query.searchName,
                    searchLabel: route.query.searchLabel,
                    searchKey: route.query.searchKey,
                }
            },
            meta: {
                title: '商品列表'
            },
        },
        {
            path: '/productDetail',
            component: () => import('./views/ProductDetail.vue'),
            props: route => {
                return {
                    shopId: parseInt(route.query.shopId),
                    productId: parseInt(route.query.productId),
                }
            },
            meta: {
                title: '商品详情',
                updateCustomerAddress: true,
            },
        },
        {
            path: '/searchProxy',
            component: () => import('./views/SearchProxy.vue'),
            props: route => {
                return {
                    typeName: route.query.typeName,
                    name: route.query.name,
                    label: route.query.label,
                }
            },
            meta: {
                title: '搜索'
            },
        },
        {
            path: '/shopSearch',
            component: () => import('./views/ShopSearch.vue'),
            props: route => {
                return {
                    shopId: parseInt(route.query.shopId),
                }
            },
            meta: {
                title: '店铺内搜索'
            },
        },
        {
            path: '/bigPromotionProductList',
            component: () => import('./views/BigPromotionProductList.vue'),
            props: route => {
                return {
                    typeName: route.query.typeName,
                    searchName: route.query.searchName,
                    searchLabel: route.query.searchLabel,
                    searchKey: route.query.searchKey,
                }
            },
            meta: {
                title: '特价秒杀'
            },
        },
        {
            path: '/shopBasketProductList',
            component: () => import('./views/ShopBasketProductList.vue'),
            props: route => {
                return {
                    searchName: route.query.searchName,
                    searchLabel: route.query.searchLabel,
                    searchKey: route.query.searchKey,
                }
            },
            meta: {
                title: '舟山市网上菜篮子-菜蓝子平价供应专区'
            }
        },
        {
            path: '/addressManager',
            component: () => import('./views/AddressManager.vue'),
            props: route => {
                return {
                    shopId: route.query.shopId != null ? parseInt(route.query.shopId) : null,
                }
            },
            meta: {
                title: '收货地址管理',
                updateCustomerAddress: true,
            },
        },

        {
            path: '/orderDetail',
            component: () => import('./views/OrderDetail.vue'),
            props: route => {
                return {
                    ifShoppingCar: parseInt(route.query.ifShoppingCar),
                    shopId: parseInt(route.query.shopId),
                }
            },
            meta: {
                title: '提交订单',
                updateCustomerAddress: true,
            },
        },

        {
            path: '/pay',
            component: () => import('./views/Pay.vue'),
            props: route => {
                return {
                    totalPayAmount: parseFloat(route.query.totalPayAmount),
                    orderId: route.query.orderId,
                    shopId: parseInt(route.query.shopId),
                }
            },
            meta: {
                title: '支付'
            },
        },
        
        {
            path: '/pbTest',
            component: () => import('./views/PbTest.vue'),
        },

        {
            path: '/search',
            component: () => import('#/common_components/Search.vue'),
            props: route => {
                return {
                    typeName: route.query.typeName,
                    searchName: route.query.searchName,
                    label: route.query.label,
                    searchResultRouter: route.query.searchResultRouter,
                }
            },
            meta: {
                title: '搜索'
            },
        },

        {
            path: '/account',
            component: () => import('./views/Account.vue'),
            meta: {
                title: '我的账户'
            },
        },

        {
            path: '/finishOrderDetail',
            component: () => import('./views/FinishOrderDetail.vue'),
            props: route => {
                return {
                    orderNumber: route.query.orderNumber,
                    orderType: parseInt(route.query.orderType),
                    orderState: parseInt(route.query.orderState),
                }
            },
            meta: {
                title: '订单详情'
            },
        },

        {
            path: '/wuLiuDetail',
            component: () => import('./views/WuLiuDetail.vue'),
            props: route => {
                return {
                    orderNumber: route.query.orderNumber,
                    orderType: parseInt(route.query.orderType),
                    orderState: parseInt(route.query.orderState),
                }
            },
            meta: {
                title: '物流详情'
            },
        },

        {
            path: '/mine',
            component: () => import('./views/Mine.vue'),
            meta: {
                title: '我的账号'
            },
        },

        {
            path: '/orderLogistics',
            component: () => import('./views/OrderLogistics.vue'),
            props: route => {
                return {
                    orderNumber: route.query.orderNumber,
                    orderType: parseInt(route.query.orderType),
                    orderState: parseInt(route.query.orderState),
                }
            },
            meta: {
                title: '物流信息'
            },
        },

        {
            path: '/orderManager',
            component: () => import('./views/OrderManager.vue'),
            meta: {
                title: '订单管理'
            },
        },
        
        {
            path: '/myCoupons',
            component: () => import('./views/MyCoupons.vue'),
            meta: {
                title: '食品安全专项消费券 '
            },
        },

        {
            path: '/coupons',
            component: () => import('./views/Coupons.vue'),
            meta: {
                title: '优惠券'
            },
            props: route => {
                return {
                    code: route.query.code,
                    typeCode: route.query.typeCode,
                }
            },
        },

        {
            path: '/couponRule',
            component: () => import('./views/CouponRule.vue'),
            meta: {
                title: '规则'
            },
        },

        {
            path: '/myCouponsNeedCheck',
            component: () => import('./views/couponNeedCheck/MyCoupons.vue'),
            meta: {
                title: '我的优惠券'
            },
        },

        {
            path: '/couponsNeedCheck',
            component: () => import('./views/couponNeedCheck/Coupons.vue'),
            meta: {
                title: '优惠券'
            },
        },

        {
            path: '/couponRuleNeedCheck',
            component: () => import('./views/couponNeedCheck/CouponRule.vue'),
            meta: {
                title: '规则'
            },
        },
        
        {
            path: '/searchResult',
            component: () => import('#/common_components/SearchResult.vue'),
            props: route => {
                return {
                    typeName: route.query.typeName,
                    searchName: route.query.searchName,
                    searchLabel: route.query.searchLabel,
                    searchKey: route.query.searchKey,
                }
            },
            meta: {
                title: '搜索结果'
            },
        },
        {
            path: '/addressDetail',
            component: () => import('#/common_components/customerAddress/AddressDetail.vue'),
            props: route => {
                return {
                    customerAddressDetail: route.query.customerAddressDetail,
                    customerName: route.query.customerName,
                    customerSex: route.query.customerSex,
                    customerMobile: route.query.customerMobile,
                    customerTag: route.query.customerTag,
                    operateType: route.query.operateType,
                    shopId: route.query.shopId ? parseInt(route.query.shopId) : null,
                }
            },

            meta: {
                title: '收货地址详情'
            },
        },

        {
            path: '/shopDeliveryFencer',
            component: () => import('#/common_components/customerAddress/ShopDeliveryFencer.vue'),
            props: route => {
                return {
                    shopId: parseInt(route.query.shopId),
                }
            },
            meta: {
                title: '店铺配送范围'
            },
        },
        {
            path: '/listAddressManager',
            component: () => import('#/common_components/customerAddress/ListAddressManager.vue'),
            props: route => {
                return {
                    shopId: route.query.shopId != null ? parseInt(route.query.shopId) : null,
                }
            },
            meta: {
                title: '收货地址管理',
                updateCustomerAddress: true,
            },
        },
        {
            path: "/shengHuoFuWu",
            component: () => import("./views/ShengHuoFuWu.vue"),
            meta: {
                title: '云商舟山-生活服务馆',
            },
        },

        {
            path: "/fuNongJiShi",
            component: () => import("./views/fuNongJiShi/Index.vue"),
            meta: {
                title: '云商舟山-福农集市',
            },
        },

        {
            path: "/huiXinShengHuo",
            component: () => import("./views/fuNongJiShi/HuiXinShengHuo.vue"),
            meta: {
                title: '云商舟山-惠新生活',
            },
        },

        {
            path: "/meiShiGuangChang",
            component: () => import("./views/MeiShiGuangChang.vue"),
            meta: {
                title: '云商舟山-美食广场',
            },
        },

        {
            path: "/categoryProductList",
            component: () => import("./views/CategoryProductList.vue"),
            meta: {
                title: '云商舟山',
            },
            props: route => {
                return {
                    typeName: route.query.typeName,
                }
            },
        },

        {
            path: "/categoryProductListCoupon",
            component: () => import("./views/CategoryProductListCoupon.vue"),
            meta: {
                title: '云商舟山',
            },
            props: route => {
                return {
                    typeName: route.query.typeName,
                }
            },
        },

        {
            path: "/shopListMap",
            component: () => import("./views/ShopListMap.vue"),
            meta: {
                title: '云商舟山',
            },
            props: route => {
                return {
                    typeName: route.query.typeName,
                }
            },
        },

        {
            path: "/shopListMapCoupon",
            component: () => import("./views/ShopListMapCoupon.vue"),
            meta: {
                title: '云商舟山',
            },
            props: route => {
                return {
                    typeName: route.query.typeName,
                }
            },
        },

        {
            path: "/innerShop",
            component: () => import("./views/innerShop/InnerShop.vue"),
            meta: {
                title: '内部商城',
            },
        }
    ]
});


routerInstance.beforeEach((to, from, next) => {
    let ifHasFetchCustomerAddress = false;
    if (to.matched.some(record => record.meta.updateCustomerAddress)) {
        ifHasFetchCustomerAddress = true;
        // 
        store.dispatch('address/fetchCustomerAddress', to.query.shopId)
    } else if (ifHasFetchCustomerAddress == false) {
        // 
        store.dispatch('address/fetchCustomerAddress')
    }

    next();
})

//
export default routerInstance;